import type { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Breadcrumb, { type Crumb } from "@/components/base/Breadcrumb";

interface PageShellProps {
  crumbs: Crumb[];
  children: ReactNode;
}

export default function PageShell({ crumbs, children }: PageShellProps) {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <div className="border-b border-background-200 bg-background-50">
          <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10 py-3">
            <Breadcrumb items={crumbs} />
          </div>
        </div>
        {children}
      </main>
      <Footer />
    </div>
  );
}